var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Facebook",on:{"click":_vm.loginWithFacebook}},[_c('q-icon',[_c('IconFacebook')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }